import React from 'react';
import { useHistory, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import HorseIcon from '../../components/global/HorseIcon';

import { useSelector } from 'react-redux';

function Bookkeeping() {
  const { t } = useTranslation();
  const history = useHistory();
  const { user, role } = useSelector(state => state.auth);

  if (role === 'admin') {
    history.push('/admin');
  }
  if (role !== 'seller') {
    history.push('/login?redirect=/seller&u=seller');
  }
  if (!user) history.push('/login');

  return (
    <div className="admin-container">
      <div className="admin-header py-3 bg-primary bg-gradient shadow">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="text-left">
                <h1 className="fs-6 text-light mb-0">
                  <span className="fa fa-book me-2"></span>
                  {t('menu_bookkeeping')}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="main-container py-3 pb-5">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="content text-left py-4">
                <div className="row g-2">
                  <div className="col-6">
                    <Link
                      to="/seller/invoice/export"
                      className="btn btn-primary w-100"
                    >
                      <span className="fa fa-file-text-o me-2"></span>
                      {t('menu_invoice')}
                    </Link>
                  </div>
                  <div className="col-6">
                    <Link
                      to="/seller/horse-list"
                      className="btn btn-primary w-100"
                    >
                      <span className="me-2" style={{ fill: 'white' }}>
                        <HorseIcon />
                      </span>
                      {t('menu_horse_list')}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <MainMenu /> */}
    </div>
  );
}

export default Bookkeeping;
